import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";
import { useFormContext } from "react-hook-form";

type TextFieldType =
    | "text" | "number" | "date" | "datetime-local";

interface Props {
    name: string;
    label?: string;
    type?: TextFieldType;
    isReadOnly?: boolean;
}

const TextField = ({
    name,
    label,
    type = "text",
    isReadOnly = false,
} : Props) => {
    const { register } = useFormContext();
    const { ref, ...rest } = register(name);
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div className={`flex flex-col gap-2`}>
            { label && <label className = {`dark:text-gray-100 mb-1`}>{label}</label> }

            <div className={`flex items-center relative w-full`}>
                <input
                    {...rest}
                    ref = {(el) => {
                        ref(el);
                        inputRef.current = el;
                    }}
                    readOnly={isReadOnly}
                    type={type}
                    className = {`bg-gray-300 read-only:text-gray-800 dark:bg-brand-900 w-full p-2 rounded-md
                        [&::-webkit-calendar-picker-indicator]:opacity-0
                    `}
                />
                {
                    (type === "date" || type === "datetime-local") &&
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            inputRef.current?.showPicker();
                        }}
                        className={`absolute right-1 inset-y-px px-2 bg-gray-300 dark:bg-brand-900`}
                    >
                        <FontAwesomeIcon icon={faCalendar} size="1x" className="text-brand-300"/>
                    </button>
                }
            </div>
        </div>
    );
};

export default TextField;